// json parse 함수
const getParsedJSON = <T>(json: string): T | null => {
  try {
    return JSON.parse(json);
  } catch {
    console.log(`${json} parse error`);
    return null;
  }
};

export default getParsedJSON;
